import React from 'react'
import { LayoutList, LayoutGrid } from 'lucide-react'
import { cn } from '../../utils/cn'

interface ViewToggleProps {
 view: 'list' | 'kanban'
 onViewChange: (view: 'list' | 'kanban') => void
 hasKanban: boolean
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onViewChange, hasKanban }) => {
 if (!hasKanban) return null

 return (
 <div className="inline-flex rounded-lg border border-border bg-card p-1 gap-0.5">
 {(['list', 'kanban'] as const).map((v) => {
 const active = view === v
 const Icon = v === 'list' ? LayoutList : LayoutGrid
 const label = v === 'list' ? 'Lista' : 'Kanban'
 return (
 <button
 key={v}
 type="button"
 onClick={() => onViewChange(v)}
 className={cn(
 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-150',
 active
 ? 'bg-accent-50 text-accent-700 dark:bg-accent-900/20 dark:text-accent-400 shadow-sm'
 : 'text-muted-foreground hover:text-foreground hover:bg-muted'
 )}
 >
 <Icon className="h-3.5 w-3.5" />
 <span className="hidden sm:inline">{label}</span>
 </button>
 )
 })}
 </div>
 )
}
